export enum Sound {
	Collision,
	Explosion,
	Heal,
	Healwave,
	Shoot,
	Death,
	WaterPlop,
	Electricity,
	ElectricalPop,

	SellChime,
	Promote,

	BloodCellDamage,
	ChainConnect,
	ChainDisconnect,
	Combine,
	PlaceCell,
	CollisionSmall,
	CollisionHeavy,
	GetResource,
	ProducedResource,
	Reward,
	HoverCell,

	UI_SOUND_START,

	Menu,
	ButtonClick,
	Heartbeat,

	MUSIC_START,

	ShopMusic,
	SimulationMusic,

	END,
}
